export enum PublicCodeDetailsParams {
  standardUuid = "standardUuid",
}
